import { Controller, useFormContext } from 'react-hook-form';
import { faLockKeyhole } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';

import { Schema } from '@typings';

import { Button, Field, Icon, Modal } from '@components';
import { ManageSecretsModal } from '@components/Modals';

export const SchemaSecret: React.FC<Schema.CommonNodeProps> = ({
  name,
  label,
  note,
  required,
}) => {
  const { control, setValue } = useFormContext();

  const handleSecretAdd = (value: string) => {
    setValue(name, value, { shouldValidate: true });
  };

  return (
    <div className="flex w-full">
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
          const isSecretAdded = !!field.value;

          return (
            <Field.Input
              {...field}
              disabled
              required={required}
              containerClassName="flex-1"
              label={label}
              className={clsx('w-full rounded-r-none !text-rebecca', {
                'pl-9': isSecretAdded,
              })}
              labelClassName="!text-neural-04"
              note={note}
              error={error?.message}
            >
              {isSecretAdded && (
                <div slot="icon" className="absolute left-3 top-5">
                  <Icon icon={faLockKeyhole} className="text-neural-04" />
                </div>
              )}
            </Field.Input>
          );
        }}
      />
      <Modal content={<ManageSecretsModal onApply={handleSecretAdd} />}>
        <Button className="h-14 rounded-l-none capitalize">
          Choose secret
        </Button>
      </Modal>
    </div>
  );
};
